module.exports = __webpack_public_path__ + "img/irb1600_x-145_m2004_rev0_01-1.prt.bbcc6e2e.jpg";